<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="Basic-Paragraph"></p>
<div class="frame-2">
<img alt="LoneStarhalftitledisplay.jpg" class="frame-3" src="image/LoneStarhalftitled_fmt.jpeg"/>
</div>
<p class="Basic-Paragraph para-style-override-1"></p>
<p class="Basic-Paragraph para-style-override-2"><span></span></p>
<p class="Basic-Paragraph para-style-override-3"><span></span></p>
<p class="Basic-Paragraph"></p>
<div class="frame-2">
<img alt="LoneStardisplay.jpg" class="frame-4" src="image/LoneStardisplay_fmt.jpeg"/>
</div>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph para-style-override-4"><span class="char-style-override-1"></span></p>
<div class="frame-2">
<img alt="PELOGO.TIF" class="frame-5" src="image/PELOGO_fmt.jpeg"/>
</div>
<p class="Basic-Paragraph para-style-override-5"></p>
<p class="Basic-Paragraph para-style-override-6">PELICAN PUBLISHING COMPANY</p>
<p class="Basic-Paragraph para-style-override-7"><span class="char-style-override-2">Gretna</span><span class="char-style-override-3"> 2016</span><span class="char-style-override-3"></span></p>
<p class="Basic-Paragraph">Copyright © 2016</p>
<p class="Basic-Paragraph">By Melanie Chrismer</p>
<p class="Basic-Paragraph">All rights reserved</p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-4">The word “Pelican” and the depiction of a pelican are</span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-4">trademarks of Pelican Publishing Company, Inc., and are</span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-4">registered in the U.S. Patent and Trademark Office.</span></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph">Library of Congress Cataloging-in-Publication Data</p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph para-style-override-8">Names: Chrismer, Melanie, author.</p>
<p class="Basic-Paragraph para-style-override-8">Title: Lone Star legacy : the Texas Rangers then and now / Melanie Chrismer.</p>
<p class="Basic-Paragraph para-style-override-8"><span>Description: Gretna, Louisiana : Pelican Publishing Company, Inc., [2016] | </span></p>
<p class="Basic-Paragraph para-style-override-8">	Includes bibliographical references and index.</p>
<p class="Basic-Paragraph para-style-override-8">Identifiers: LCCN 2015050299 | ISBN 9781455621040 (pbk. : alk. paper)</p>
<p class="Basic-Paragraph para-style-override-8">Subjects: LCSH: Texas Rangers--Juvenile literature. | Law enforcement--Texas--History--Juvenile literature. | Texas--History--Juvenile literature.</p>
<p class="Basic-Paragraph para-style-override-8">Classification: LCC F391 .C486 2016 | DDC 363.2/09764--dc23 LC record available at <a href="http://lccn.loc.gov/2015050299" target="_blank"><span class="Hyperlink char-style-override-5">http://lccn.loc.gov/2015050299</span></a><span class="Hyperlink char-style-override-5"></span></p>
<p class="Basic-Paragraph"><span class="Hyperlink char-style-override-5"></span></p>
<p class="Basic-Paragraph"><span class="Hyperlink char-style-override-5"></span></p>
<p class="Basic-Paragraph"><span class="Hyperlink char-style-override-5"></span></p>
<p class="Basic-Paragraph"><span class="Hyperlink char-style-override-5"></span></p>
<p class="Basic-Paragraph"><span class="Hyperlink char-style-override-5"></span></p>
<div class="frame-2">
<img alt="1597.jpg" class="frame-6" src="image/1597.jpg"/>
</div>
<p class="Basic-Paragraph"><span class="Hyperlink char-style-override-5"></span></p>
<p class="Basic-Paragraph para-style-override-9">Printed in the United States of America</p>
<p class="Basic-Paragraph">Published by Pelican Publishing Company, Inc.</p>
<p class="Basic-Paragraph para-style-override-2">1000 Burmaster Street, Gretna, Louisiana 70053<span></span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-4">To the Texas Rangers, past, present, and future. May the Lord keep our Rangers safe, our liberty secure, and our Texas free.</span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-4"></span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-4">For Lauren and Tim</span></p>
<p class="Basic-Paragraph para-style-override-1"><span class="char-style-override-4">with love</span></p>
<p class="Basic-Paragraph para-style-override-2"><span class="char-style-override-4"></span></p>
<p class="Basic-Paragraph"><span class="char-style-override-6">The great peace officer must have three qualities: courage, intelligence, and character. . . . Such a man cannot be scared, bought, or fooled.</span></p>
<p class="Basic-Paragraph"><span class="char-style-override-7">Walter Prescott Webb <br/></span><span class="char-style-override-6">The Texas Rangers: A Century of Frontier Defense</span></p>
<p class="Basic-Paragraph para-style-override-2"><span></span></p>
<p class="x-1-chapter-number-15"></p>
<p class="x-2-ch-title-15">Contents<br/></p>
<p class="Basic-Paragraph para-style-override-9">	Acknowledgments	 9</p>
<p class="Basic-Paragraph para-style-override-9">	Introduction	 11</p>
<p class="Basic-Paragraph para-style-override-9">Chapter 1	One Legacy	 15</p>
<p class="Basic-Paragraph para-style-override-9">Chapter 2	Beginning Times	 21</p>
<p class="Basic-Paragraph para-style-override-9">Chapter 3	The War for Independence	29</p>
<p class="Basic-Paragraph para-style-override-9">Chapter 4	The Republic	 35</p>
<p class="Basic-Paragraph para-style-override-9">Chapter 5	Mexican Invasions Continue	 45</p>
<p class="Basic-Paragraph para-style-override-9">Chapter 6	Republic Law Becomes State Law	 49</p>
<p class="Basic-Paragraph para-style-override-9">Chapter 7	Return to Service	 57</p>
<p class="Basic-Paragraph para-style-override-9">Chapter 8	A New Century	 67</p>
<p class="Basic-Paragraph para-style-override-9">Chapter 9	The Depression Years	 81</p>
<p class="Basic-Paragraph para-style-override-9">Chapter 10	The DPS Takes the Reins	 87</p>
<p class="Basic-Paragraph para-style-override-9">Chapter 11	The Last Third of the Twentieth Century	 97</p>
<p class="Basic-Paragraph para-style-override-9">Chapter 12	Texas Ranger Teamwork	 105</p>
<p class="Basic-Paragraph para-style-override-9">Chapter 13	Today’s Texas Ranger	 111</p>
<p class="Basic-Paragraph para-style-override-9">Chapter 14	Honoring the Legacy	 119</p>
<p class="Basic-Paragraph para-style-override-9">	Notes	 125</p>
<p class="Basic-Paragraph para-style-override-9">	Bibliography	 131</p>
<p class="Basic-Paragraph para-style-override-9">	Index	 135</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LONHeFM01.vue?9ed09ff2